import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function PSRManager() {
  const [records, setRecords]   = useState([]);
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({ employee_id: '', week_no: '', score: '', remarks: '' });
  const [editing, setEditing]   = useState(null);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]     = useState('');
  const [filterEmp, setFilterEmp] = useState('');

  const load = () => {
    const q = filterEmp ? `?employee_id=${filterEmp}` : '';
    api.get(`/psr${q}`).then(r => setRecords(r.data.data.records || [])).finally(() => setLoading(false));
  };

  useEffect(() => {
    api.get('/users/employees').then(r => setEmployees(r.data.data));
  }, []);

  useEffect(() => { load(); }, [filterEmp]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      if (editing) { await api.put(`/psr/${editing}`, form); setEditing(null); }
      else          { await api.post('/psr', form); }
      setForm({ employee_id: '', week_no: '', score: '', remarks: '' });
      setMsg('Saved!');
      load();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) {
      setMsg(err.response?.data?.message || 'Failed');
    } finally {
      setSaving(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this PSR entry?')) return;
    await api.delete(`/psr/${id}`);
    load();
  };

  const edit = (r) => {
    setEditing(r.id);
    setForm({ employee_id: r.employee_id, week_no: r.week_no, score: r.score, remarks: r.remarks || '' });
  };

  const scoreColor = s => +s >= 80 ? 'success' : +s >= 60 ? 'warning' : 'danger';

  return (
    <div className="row g-4">
      <div className="col-md-4">
        <div className="content-section">
          <h6>{editing ? 'Edit PSR Entry' : 'Add PSR Entry'}</h6>
          {msg && <div className={`alert py-2 small ${msg === 'Saved!' ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}
          <form onSubmit={save}>
            <div className="mb-3">
              <label className="form-label small fw-semibold">Employee</label>
              <select className="form-select form-select-sm" value={form.employee_id} onChange={e=>setForm({...form,employee_id:e.target.value})} required>
                <option value="">Select employee...</option>
                {employees.map(e => <option key={e.id} value={e.id}>{e.name} ({e.employee_id})</option>)}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label small fw-semibold">Week No</label>
              <input type="number" className="form-control form-control-sm" value={form.week_no} onChange={e=>setForm({...form,week_no:e.target.value})} required min={1} />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-semibold">Score (0–100)</label>
              <input type="number" className="form-control form-control-sm" value={form.score} onChange={e=>setForm({...form,score:e.target.value})} required min={0} max={100} step={0.1} />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-semibold">Remarks</label>
              <textarea className="form-control form-control-sm" rows={3} value={form.remarks} onChange={e=>setForm({...form,remarks:e.target.value})} />
            </div>
            <div className="d-flex gap-2">
              <button type="submit" className="btn btn-primary btn-sm flex-grow-1" disabled={saving}>{saving ? 'Saving...' : editing ? 'Update' : 'Add'}</button>
              {editing && <button type="button" className="btn btn-secondary btn-sm" onClick={()=>{setEditing(null);setForm({employee_id:'',week_no:'',score:'',remarks:''});}}>Cancel</button>}
            </div>
          </form>
        </div>
      </div>

      <div className="col-md-8">
        <div className="d-flex gap-2 mb-3">
          <select className="form-select form-select-sm" style={{maxWidth:200}} value={filterEmp} onChange={e=>setFilterEmp(e.target.value)}>
            <option value="">All Employees</option>
            {employees.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
        {loading ? (
          <div className="text-center py-4"><div className="spinner-border text-primary" /></div>
        ) : (
          <div className="table-card">
            <table className="table table-hover align-middle mb-0">
              <thead><tr><th>Employee</th><th>Week</th><th>Score</th><th>Remarks</th><th>Date</th><th></th></tr></thead>
              <tbody>
                {records.length === 0 ? (
                  <tr><td colSpan={6} className="text-center text-muted py-3">No PSR records</td></tr>
                ) : records.map(r => (
                  <tr key={r.id}>
                    <td className="small">{r.employee_name} <span className="text-muted">({r.emp_id})</span></td>
                    <td><span className="badge bg-primary-subtle text-primary">W{r.week_no}</span></td>
                    <td>
                      <span className={`fw-bold text-${scoreColor(r.score)}`}>{r.score}%</span>
                    </td>
                    <td className="small text-muted" style={{maxWidth:150}}>{r.remarks || '—'}</td>
                    <td className="small text-muted">{new Date(r.created_at).toLocaleDateString('en-IN')}</td>
                    <td>
                      <div className="d-flex gap-1">
                        <button className="btn btn-outline-primary btn-sm py-0 px-1" onClick={()=>edit(r)}><i className="bi bi-pencil" /></button>
                        <button className="btn btn-outline-danger btn-sm py-0 px-1" onClick={()=>del(r.id)}><i className="bi bi-trash" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
